/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

.wireframe-container-sampler-plus-s {
  @include mixins.page-grid-basics;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: auto auto auto;
  grid-template-areas:
    'sampler-plus-s sampler-plus-s sampler-plus-s'
    '. . .'
    '. . .';
}

.sampler-plus-s {
  grid-area: sampler-plus-s;
}
